import { Grid, Container } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";

import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import UpdateRoundedIcon from "@mui/icons-material/UpdateRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import FolderZipRoundedIcon from "@mui/icons-material/FolderZipRounded";
import LinkRoundedIcon from "@mui/icons-material/LinkRounded";
import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";
import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import AssessmentRoundedIcon from "@mui/icons-material/AssessmentRounded";
import AssignmentLateRoundedIcon from "@mui/icons-material/AssignmentLateRounded";
import HistoryEduRoundedIcon from "@mui/icons-material/HistoryEduRounded";
import SyncAltRoundedIcon from "@mui/icons-material/SyncAltRounded";

export default function Lawsuit() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasPermission("subir demandas") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Precargar Títulos"
              subtitle="Título electrónico (JEX) por ZIP"
              icon={<FolderZipRoundedIcon />}
              color="#f59e0b"
              to="/lawsuit/upload"
            />
          </Grid>
        )}

        {hasPermission("actualizar demandas") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Actualizar Títulos"
              subtitle="Actualizar títulos electrónicos (JEX)"
              icon={<UpdateRoundedIcon />}
              color="#2563eb"
              to="/lawsuit/upload/file/update"
            />
          </Grid>
        )}

        {hasPermission("subir demandas archivo") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Cargar / Eliminar"
              subtitle="Cargar (SAC) / Eliminar (JEX) por archivo"
              icon={<SwapHorizRoundedIcon />}
              color="#8b5cf6"
              to="/lawsuit/upload/file"
            />
          </Grid>
        )}

        {hasPermission("generar demandas concluidas") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Importar Concluidas"
              subtitle="Importar expedientes con títulos concluidos"
              icon={<UploadFileRoundedIcon />}
              color="#10b981"
              to="/lawsuit/import/concluded"
            />
          </Grid>
        )}

        {hasPermission("asociar demanda expediente") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Asociar / Desasociar"
              subtitle="Vincular títulos con expedientes"
              icon={<LinkRoundedIcon />}
              color="#0ea5e9"
              to="/lawsuit/associate/legal/file"
            />
          </Grid>
        )}

        {hasPermission("ver demandas") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Ver por Abogados"
              subtitle="Títulos electrónicos por abogado"
              icon={<BadgeRoundedIcon />}
              color="#22c55e"
              to="/lawsuit/get/lawyers"
            />
          </Grid>
        )}

        {hasPermission("ver demandas todas") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Ver Todas"
              subtitle="Títulos electrónicos (todos)"
              icon={<ManageSearchRoundedIcon />}
              color="#64748b"
              to="/lawsuit/all"
            />
          </Grid>
        )}

        {hasPermission("ver demandas fallidas") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="No procesados"
              subtitle="Archivos / títulos fallidos"
              icon={<ErrorOutlineRoundedIcon />}
              color="#ef4444"
              to="/lawsuit/failure"
            />
          </Grid>
        )}

        {hasPermission("cargar demandas historicas") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Cargar Históricas"
              subtitle="Registrar títulos ya concluidos sin PDF"
              icon={<HistoryEduRoundedIcon />}
              color="#7c3aed"
              to="/lawsuit/upload/historical"
            />
          </Grid>
        )}

        {hasPermission("actualizar expediente y juc id demandas") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Actualizar Estado y ID"
              subtitle="Completar el JUC ID y el Estado en títulos existentes"
              icon={<SyncAltRoundedIcon />}
              color="#0891b2"
              to="/lawsuit/update/juc"
            />
          </Grid>
        )}

        {hasPermission("ver demandas sin vincular") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="No Vinculadas"
              subtitle="Títulos a completar manualmente"
              icon={<AssignmentLateRoundedIcon />}
              color="#f97316"
              to="/lawsuit/unlinked"
            />
          </Grid>
        )}

        {hasPermission("exportar demandas") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Reportes"
              subtitle="Exportar datos de títulos"
              icon={<AssessmentRoundedIcon />}
              color="#8b5cf6"
              to="/lawsuit/export/data"
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
